/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint-disable-next-line max-len */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state", "payload"] }] */
import { uuid } from 'vue-uuid';

import axios from 'axios';

import api from '../../utils/api';

const state = {
  // PATCH PRICES SET HERE
  customPatchPrice: 450,
  catalogPatchPrice: 450, // catalog is catalog or submissions

  loading: false,
  loadingTax: false,
  loadingCoupon: false,

  couponDescription: '',
  couponErrorMessages: [],

  // ACTUAL CART OBJECT
  cart: {
    emailAddress: '',
    publicId: 'guest',
    shippingAddress: {
      emailAddress: '',
      fullName: '',
      company: '',
      line1: '',
      line2: '',
      city: '',
      state: '',
      zipcode: '',
      taxCode: '00000',
    },
    hats: [],
    patches: [],
    customPatches: [],
    couponCode: '',
    subtotal: 0,
    discount: null,
    salesTax: 0,
    vendorFee: 0,
    total: null,
    token: '',
  },

  // order confirmation invoice
  invoice: {},

  // loading status while placing order
  placingOrder: false,

  // error state if checkout failed
  checkoutFailed: false,
};

const getters = {
  totalItems() {
    let total = 0;
    total += state.cart.hats.length;
    total += state.cart.patches.length;
    total += state.cart.customPatches.length;
    return total;
  },
  cartItemsSubtotal() {
    let subtotal = 0;
    const itemSets = ['hats', 'patches', 'customPatches'];
    for (let i = 0; i < itemSets.length; i++) {
      const itemSet = itemSets[i];
      for (let x = 0; x < state.cart[itemSet].length; x++) {
        const price = parseFloat(state.cart[itemSet][x].unitPrice);
        const qty = state.cart[itemSet][x].quantity;
        subtotal += price * qty;
      }
    }
    return subtotal;
  },
  cartItemsTotal() {
    let total = 0;
    total += getters.cartItemsSubtotal();
    if (state.cart.discount !== '') {
      total -= state.cart.discount;
    }
    return total;
  },
};

const mutations = {
  setLoadingTax(state, { loading }) {
    state.loadingTax = loading;
  },
  setCartTaxCode(state, taxCode) {
    state.cart.shippingAddress.taxCode = taxCode;
  },
  setEmail(state, email) {
    state.cart.emailAddress = email;
  },
  setPublicId(state, publicId) {
    state.cart.publicId = publicId;
  },
  setShippingAddress(state, shippingAddress) {
    state.cart.shippingAddress = shippingAddress;
  },
  setLoadingCoupon(state, { loading }) {
    state.loadingCoupon = loading;
  },
  setCartCouponCode(state, couponCode) {
    state.cart.couponCode = couponCode;
  },
  setCouponErrorMessage(state, message) {
    state.couponErrorMessages = [];
    if (message !== null) {
      state.couponErrorMessages.push(message);
    }
  },
  setCouponDescription(state, description) {
    state.couponDescription = description;
  },
  setCartDiscount(state, discount) {
    state.cart.discount = discount;
  },
  setCartSubtotal(state, subtotal) {
    state.cart.subtotal = subtotal;
  },
  setCartTotal(state, total) {
    state.cart.total = total;
  },
  setCartSalesTax(state, salesTax) {
    state.cart.salesTax = salesTax;
  },
  setCartVendorFee(state, vendorFee) {
    state.cart.vendorFee = vendorFee;
  },

  setStripeToken(state, token) {
    state.cart.token = token;
  },

  setPlacingOrder(state, { loading }) {
    state.placingOrder = loading;
  },
  setCheckoutFailed(state, { status }) {
    state.checkoutFailed = status;
  },

  setInvoice(state, invoice) {
    state.invoice = invoice;
  },
  initCart(state) {
    state.cart = {
      emailAddress: '',
      publicId: 'guest',
      shippingAddress: {
        emailAddress: '',
        fullName: '',
        company: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        zipcode: '',
        taxCode: '00000',
      },
      hats: [],
      patches: [],
      customPatches: [],
      couponCode: '',
      subtotal: 0,
      discount: null,
      salesTax: 0,
      vendorFee: 0,
      total: 0,
      token: '',
    };
  },

  // CART ITEMS
  addCartHat(state, hat) {
    const hatInCart = state.cart.hats.find(cartHat => cartHat.sku === hat.sku);
    if (!hatInCart) {
      state.cart.hats.push(hat);
    } else {
      hatInCart.quantity++;
    }
  },
  addCartPatch(state, patch) {
    const patchInCart = state.cart.patches.find(
      cartPatch => cartPatch.imageId === patch.imageId,
    );
    if (!patchInCart) {
      state.cart.patches.push(patch);
    } else {
      patchInCart.quantity++;
    }
  },
  addCartCustomPatch(state, customPatch) {
    // find a custom with the same image (dataURL)
    const customInCart = state.cart.customPatches.find(
      cartCustom => cartCustom.imageId === customPatch.imageId,
    );
    if (!customInCart) {
      state.cart.customPatches.push(customPatch);
    } else {
      customInCart.quantity++;
    }
  },
  removeCartItem(state, { itemSet, item }) {
    let searchProperty = 'imageId';
    if (itemSet === 'hats') {
      searchProperty = 'sku';
    }
    const itemInCart = state.cart[itemSet].find(
      cartItem => cartItem[searchProperty] === item[searchProperty],
    );
    if (itemInCart) {
      const itemIndex = state.cart[itemSet].indexOf(itemInCart);
      if (itemIndex > -1) {
        state.cart[itemSet].splice(itemIndex, 1);
      }
    }
  },
  incrementCartItem(state, { itemSet, item }) {
    let searchProperty = 'imageId';
    if (itemSet === 'hats') {
      searchProperty = 'sku';
    }
    const itemInCart = state.cart[itemSet].find(
      cartItem => cartItem[searchProperty] === item[searchProperty],
    );
    if (itemInCart) {
      itemInCart.quantity++;
    }
  },
  decrementCartItem(state, { itemSet, item }) {
    let searchProperty = 'imageId';
    if (itemSet === 'hats') {
      searchProperty = 'sku';
    }
    const itemInCart = state.cart[itemSet].find(
      cartItem => cartItem[searchProperty] === item[searchProperty],
    );
    if (itemInCart) {
      itemInCart.quantity--;
    }
  },
};

const actions = {
  resetCheckoutStatus({ commit }) {
    commit('setCheckoutFailed', { status: false });
    commit('setPlacingOrder', { status: false });
    commit('setInvoice', {});
  },
  clearCart({ commit }) {
    commit('initCart');
  },
  clearInvoice({ commit }) {
    commit('setInvoice', {});
  },
  // CART ITEMS
  addHatToCart({ commit, dispatch }, hat) {
    const cartItem = {
      name: hat.name,
      sku: hat.sku,
      slug: hat.slug, // needed for data lookup
      unitPrice: null,
      quantity: 1,
    };
    if (hat.salePrice) {
      cartItem.unitPrice = hat.salePrice;
    } else {
      cartItem.unitPrice = hat.retailPrice;
    }
    commit('addCartHat', cartItem);
    // recalculate discount
    const code = state.cart.couponCode;
    if (code) {
      dispatch('applyCouponCode', code);
    }
  },
  addPatchToCart({ commit, dispatch }, { patch, patchGroup }) {
    const cartItem = {
      name: patch.name,
      imageId: patch.imageId,
      sku: patch.sku,
      unitPrice: state.catalogPatchPrice,
      quantity: 1,
      patchGroup,
    };
    commit('addCartPatch', cartItem);
    // recalculate discount
    const code = state.cart.couponCode;
    if (code) {
      dispatch('applyCouponCode', code);
    }
  },
  addCustomPatchToCart({ state, commit, dispatch }, customURL) {
    const customPatch = {
      dataURL: customURL,
      // dataShortURL: customURL.slice(-128),
      imageId: uuid.v4(),
      unitPrice: state.customPatchPrice,
      quantity: 1,
    };
    commit('addCartCustomPatch', customPatch);
    // recalculate discount
    const code = state.cart.couponCode;
    if (code) {
      dispatch('applyCouponCode', code);
    }
  },
  removeFromCart({ commit, dispatch }, { itemSet, item }) {
    commit('removeCartItem', { itemSet, item });
    // recalculate discount
    const code = state.cart.couponCode;
    if (code) {
      dispatch('applyCouponCode', code);
    }
  },
  increaseQuantity({ commit, dispatch }, { itemSet, item }) {
    commit('incrementCartItem', { itemSet, item });
    // recalculate discount
    const code = state.cart.couponCode;
    if (code) {
      dispatch('applyCouponCode', code);
    }
  },
  decreaseQuantity({ commit, dispatch }, { itemSet, item }) {
    commit('decrementCartItem', { itemSet, item });
    // recalculate discount
    const code = state.cart.couponCode;
    if (code) {
      dispatch('applyCouponCode', code);
    }
  },

  // CUSTOMER DATA - Shipping Address, Email, ID
  loadUserData({ commit }, { email, publicId, shippingAddress }) {
    commit('setEmail', email);
    commit('setPublicId', publicId);
    commit('setShippingAddress', shippingAddress);
  },
  loadPublicId({ commit, rootState }) {
    const { publicId } = rootState.user.currentUser;
    if (publicId) {
      commit('setPublicId', publicId);
    }
  },

  // DISCOUNT CODE
  applyCouponCode({ state, commit, dispatch }, couponCode) {
    commit('setLoadingCoupon', { loading: true });
    return new Promise((resolve, reject) => {
      commit('setCartCouponCode', couponCode);
      // format request data
      const requestData = JSON.parse(JSON.stringify(state.cart));
      for (let i = 0; i < requestData.customPatches.length; i++) {
        delete requestData.customPatches[i].dataURL;
      }
      // POST to API
      api
        .postData('/checkout/couponcodes/', requestData)
        .then((res) => {
          if (res.data.message) {
            commit('setLoadingCoupon', { loading: false });
            commit('setCouponErrorMessage', res.data.message);
            dispatch('clearCouponCode');
            reject();
          } else {
            commit('setLoadingCoupon', { loading: false });
            const resData = res.data.cart;
            commit('setCouponErrorMessage', null);
            commit('setCartCouponCode', resData.couponCode);
            commit('setCouponDescription', resData.description);
            commit('setCartDiscount', resData.discount);
            resolve();
          }
        })
        .catch(() => {
          commit('setLoadingCoupon', { loading: false });
          dispatch('clearCouponCode');
          reject();
        });
    });
  },
  clearCouponCode({ commit }) {
    commit('setCartCouponCode', '');
    commit('setCouponDescription', '');
    commit('setCartDiscount', null);
  },

  // TAX CODE
  getTaxCode({ commit }) {
    commit('setLoadingTax', { loading: true });
    return new Promise((resolve, reject) => {
      // format request data
      const requestData = JSON.parse(JSON.stringify(state.cart));
      for (let i = 0; i < requestData.customPatches.length; i++) {
        delete requestData.customPatches[i].dataURL;
      }
      // POST to API
      api
        // CHANGE METHOD + ENDPOINT TO WHATEVER
        .postData('/checkout/salestax', requestData)
        .then((res) => {
          const { taxCode } = res.data.shippingAddress;
          commit('setLoadingTax', { loading: false });
          commit('setCartTaxCode', taxCode);
          commit('setCartVendorFee', res.data.vendorFee);
          commit('setCartTotal', res.data.total);
          commit('setCartSalesTax', res.data.salesTax);
          resolve(taxCode);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // SET CART TOTALS
  calculateCartSubtotal({ commit }) {
    return new Promise((resolve) => {
      let subtotal = 0;
      const itemSets = ['hats', 'patches', 'customPatches'];
      for (let i = 0; i < itemSets.length; i++) {
        const itemSet = itemSets[i];
        for (let x = 0; x < state.cart[itemSet].length; x++) {
          const price = parseFloat(state.cart[itemSet][x].unitPrice);
          const qty = state.cart[itemSet][x].quantity;
          subtotal += price * qty;
        }
      }
      commit('setCartSubtotal', subtotal);
      resolve();
    });
  },

  /* ------------*
   * PLACE ORDER *
   *------------ */

  // start loader
  placingOrderOn({ commit }) {
    commit('setPlacingOrder', { loading: true });
  },

  // add stripe token to cart object
  addCartToken({ commit }, token) {
    commit('setStripeToken', token);
  },

  // place the order
  placeOrder({ commit }) {
    return new Promise((resolve, reject) => {
      // 1. Build API request to send any custom patches
      const customsRequestArray = [];
      for (let i = 0; i < state.cart.customPatches.length; i++) {
        const custom = state.cart.customPatches[i];
        const requestData = {
          publicId: state.cart.publicId,
          dataURL: custom.dataURL,
          imageId: custom.imageId,
        };
        const request = api.postData('/customs/', requestData);
        customsRequestArray.push(request);
      }

      // 2. Build API request to send cart data
      // deep clone object
      const cartRequest = JSON.parse(JSON.stringify(state.cart));
      for (let i = 0; i < cartRequest.customPatches.length; i++) {
        delete cartRequest.customPatches[i].dataURL;
      }
      // move submissions from `patches` to `customPatches`
      const submissions = cartRequest.patches.filter(patch => patch.patchGroup === 'submissions');
      cartRequest.customPatches = cartRequest.customPatches.concat(submissions);
      cartRequest.patches = cartRequest.patches.filter(patch => patch.patchGroup === 'catalog');

      // 3. Execute all API requests
      axios
        .all(customsRequestArray)
        .then(axios.spread(() => api.postData('/checkout/payment', cartRequest)))
        .then((res) => {
          commit('setInvoice', res.data);
          commit('setPlacingOrder', { loading: false });
          resolve();
        })
        .catch((error) => {
          commit('setPlacingOrder', { status: false });
          commit('setCheckoutFailed', { status: true });
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
